export function getExcerpt(string, length = 30) {
  return string.length > length
    ? string.substr(0, length - 2) + '..'
    : string;
}

export function isHex(string) {
  const pattern = /^#[0-9A-F]{6}$/i;

  return pattern.test(string);
}

export function copyToClipboard(string) {
  const el = document.createElement('textarea');
  el.value = string;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}